<div class="brkSideNav">
  <div
    *ngFor="let item of items; let idx = index"
    (click)="
      item.submenu && item.submenu.length ? $event.stopPropagation() : ''
    "
    [ngClass]="{
      'us-employer-only-nav': isUsEmployerOnly,
      'nav-item-expanded-height': item.text === 'Continuing Education'
    }"
  >
    <div *ngIf="item.submenu && item.submenu.length > 0">
      <mat-accordion>
        <mat-expansion-panel
          (afterExpand)="onMatExpanded(item.text, idx)"
          [expanded]="item.open || item.text == activeNavMenu"
          [ngClass]="
            item.text === 'U.S. Employer'
              ? 'use'
              : item.text === 'Individual and Family'
              ? 'ifp'
              : item.text === 'Medicare Advantage'
              ? 'ma'
              : item.text === 'Cigna Supplemental'
              ? 'csb'
              : item.text === 'Small Group Plans'
              ? 'sgp'
              : ''
          "
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <a
                #navItem
                mat-list-item
                role="listitem"
                tabindex="0"
                class="nav-item"
                (click)="makeActiveBrokerTemp(item.text)"
                [ngClass]="{
                  'router-link-active': checkActiveRoute(item)
                }"
              >
                <div
                  class="active-strip"
                  [attr.data-test-id]="'snActiveRoutePage-' + idx"
                ></div>
                <div
                  class="icon-wrap {{ item.icon }}"
                  [attr.data-test-id]="'snMenuIconClass-' + idx"
                ></div>
                <div
                  class="menuLabelText"
                  data-test-id="left-nav-menu"
                  *ngIf="item.text === 'U.S. Employer'"
                >
                  <div fxLayout="row">U.S. Employer<br /></div>
                </div>
                <div
                  *ngIf="item.text !== 'U.S. Employer'"
                  class="menuLabelText"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  data-test-id="left-nav-menu"
                >
                  {{ item.text }}
                </div>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div
            *ngFor="let child of item.submenu"
            [ngClass]="{
              'nav-sub-menu-item router-link-active':
                checkActiveSubMenuRoute(child),
              'nav-item-expanded-height': child.text === 'Continuing Education'
            }"
          >
            <cigna-brk-nav-item-sub-menu
              *ngIf="child.text === 'Tools' && child.submenu.length"
              [item]="child"
              [parentItem]="item"
              [idx]="idx"
              [isImpersonatorFlag]="isImpersonatorFlag"
              [hasIfpAdminMenu]="hasIfpAdminMenu"
              (itemClicked)="onNavItemSubMenuItemClicked($event)"
            >
            </cigna-brk-nav-item-sub-menu>
            <cigna-brk-nav-item-sub-menu
              *ngIf="child.text !== 'Tools'"
              [item]="child"
              [parentItem]="item"
              [idx]="idx"
              [isImpersonatorFlag]="isImpersonatorFlag"
              [hasIfpAdminMenu]="hasIfpAdminMenu"
              (itemClicked)="onNavItemSubMenuItemClicked($event)"
            >
            </cigna-brk-nav-item-sub-menu>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div
      *ngIf="!item.submenu || item.submenu.length === 0"
      [ngClass]="
        item.text === 'Dashboard'
          ? 'dboard'
          : item.text === 'Prescription Drug Plan'
          ? 'pdp'
          : ''
      "
      [ngClass]="{
        dboard: item.text === 'Dashboard',
        pdp: item.text === 'Prescription Drug Plan',
        'impersonator-disabled':
          isImpersonatorFlag &&
          (item.text === 'Plan & Product Training Hub' ||
            item.text === 'Continuing Education'),
        'nav-item-expanded-height': item.text === 'Continuing Education'
      }"
    >
      <a
        #navItem
        mat-list-item
        role="listitem"
        tabindex="0"
        class="nav-item"
        (click)="
          item.text === 'Tools'
            ? usEmpToolsClicked($event)
            : isImpersonatorFlag &&
              (item.text === 'Plan & Product Training Hub' ||
                item.text === 'Continuing Education')
            ? null
            : subMenuItemClicked(item)
        "
        [ngClass]="{
          'router-link-active': checkActiveRoute(item),
          'nav-item-expanded-height': item.text === 'Continuing Education'
        }"
      >
        <div
          class="active-strip"
          [attr.data-test-id]="'snActiveRoutePage-' + idx"
        ></div>
        <div
          class="icon-wrap {{ item.icon }}"
          [attr.data-test-id]="'snMenuIconClass-' + idx"
        ></div>
        <div
          class="menuLabelText"
          [ngClass]="{
            'align-items-baseline': isUsEmployerOnly,
          }"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          data-test-id="left-nav-menu"
        >
          <div *ngIf="item.text === 'Continuing Education'">
            {{ item.text }}
            <br />
            <div class="free-text">Free*</div>
          </div>
          <div *ngIf="item.text !== 'Continuing Education'">
            {{ item.text }}
          </div>
          <div></div>
          <cigna-icon
            *ngIf="
              isUsEmployerOnly &&
              (item.text === 'Plan & Product Training Hub' ||
                item.text === 'Continuing Education')
            "
            class="cfb-ext-icon"
            [ngClass]="{
              'continuing-education-ext-icon-margin':
                item.text === 'Continuing Education',
              'plan-product-training-hub-ext-icon-margin':
                item.text === 'Plan & Product Training Hub'
            }"
          ></cigna-icon>
          <cigna-icon
            *ngIf="item.text === 'Tools'"
            class="caret-right"
          ></cigna-icon>
        </div>
      </a>
    </div>
  </div>
</div>

<div
  #usEmpToolsTrigger="matMenuTrigger"
  [matMenuTriggerFor]="afterMenu"
  id="usEmpToolsMenu"
  class="sideNavSubMenu"
>
  <mat-menu #afterMenu="matMenu" class="usEmpToolsMenu">
    <div
      *ngFor="let tool of usEmpTools"
      fxLayout="row"
      fxLayoutAlign="space-between"
      class="us-emp-tool-menu-item"
      [ngClass]="{ 'impersonator-disabled': isImpersonatorFlag }"
      (click)="
        !isImpersonatorFlag ? usEmpToolItemClicked(tool.text, tool.route) : null
      "
    >
      <div>
        {{ tool.text }}
      </div>
      <cigna-icon type="external-link"></cigna-icon>
    </div>
  </mat-menu>
</div>
